<template>
  <div class="c-loading">
    <div :class="['loading-overlay', overlayClass]"></div>
    <div class="loading-content">
      <v-progress-circular
        indeterminate
        :size="size"
        :width="width"
        :color="color"
      ></v-progress-circular>
      <div class="text-5 primary--text mt-1" v-if="!!loadingText">{{ loadingText }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loadingText: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: Number,
      default: 18,
    },
    width: {
      type: Number,
      default: 2,
    },
    overlayClass: String,
  },
};
</script>
<style lang="scss">
.c-loading {
  z-index: 4;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .loading-overlay {
    background-color: rgba(255, 255, 255, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .loading-content {
    z-index: 6;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 95vh;
  }
}
.theme--dark {
  .loading-overlay {
    background-color: rgba(0, 0, 0, 0.6) !important;
  }
}
</style>
